import Reveal from "./Reveal";
import { FEATURES, TIKTOK_URL, INSTAGRAM_URL } from "../content";
import { Sticker } from "./Stickers";

export default function Features() {
  return (
    <section id="features" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-16">
        <Reveal>
          <p
            className="max-w-4xl font-display text-2xl font-extrabold leading-[1.18] tracking-tight text-ink md:text-4xl"
            data-testid="features-lead"
          >
            Purpose-built for press-on professionals,{" "}
            <span className="relative inline-block -rotate-1">
              <span className="relative z-10">nailtape™</span>
              <span className="absolute inset-x-[-4px] bottom-[0.08em] z-0 h-[38%] bg-pastel-pink" />
            </span>{" "}
            streamlines your workflow, handles the busy work, and turns your
            everyday operations into insights you can actually use.
          </p>
        </Reveal>

        <div className="mt-14 border-t-2 border-ink md:mt-16">
          {FEATURES.map((f, i) => (
            <Reveal key={f.id} delay={i * 0.03} className="border-b-2 border-ink">
              <div
                className="grid grid-cols-1 gap-3 py-8 transition-colors duration-200 hover:bg-pastel-blue/20 md:grid-cols-12 md:items-center md:gap-8 md:py-9"
                data-testid={`feature-row-${f.id}`}
              >
                <span className="md:col-span-1">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border-2 border-ink font-display text-sm font-extrabold text-ink shadow-chunk ${
                      ["bg-pastel-pink", "bg-pastel-mint", "bg-pastel-blue"][
                        i % 3
                      ]
                    }`}
                  >
                    {f.num}
                  </span>
                </span>
                <h3 className="font-display text-2xl font-extrabold tracking-tight text-ink md:col-span-4">
                  {f.term}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-ink/70 md:col-span-7">
                  {f.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal
          className="mt-14 rounded-2xl border-2 border-ink bg-pastel-mint/40 p-7 shadow-chunk md:p-9"
          data-testid="integrations-band"
        >
          <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
            <p className="font-display text-xl font-extrabold tracking-tight text-ink md:text-2xl">
              Plugs into where you already sell.
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <Sticker rotate="-rotate-2" bg="bg-white" className="text-sm">
                Etsy
              </Sticker>
              <Sticker rotate="rotate-2" bg="bg-white" className="text-sm">
                TikTok Shop
              </Sticker>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-20 md:mt-28">
          <div className="relative">
            <img
              src="/images/studio_flatlay.jpeg"
              alt="A press-on artist's workspace in warm natural light"
              className="aspect-[16/9] w-full rotate-[0.75deg] rounded-3xl border-2 border-ink object-cover shadow-chunk-lg md:aspect-[21/9]"
              data-testid="features-environment-image"
            />
            <div className="absolute -top-8 right-6 hidden md:block">
              <Sticker rotate="rotate-3" bg="bg-pastel-blue">
                Run from one phone
              </Sticker>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-16 flex flex-col gap-5 border-t-2 border-ink pt-8 md:flex-row md:items-center md:justify-between">
          <p className="max-w-xl font-display text-2xl font-extrabold leading-snug tracking-tight text-ink md:text-3xl">
            Built for the artists turning press-ons into serious businesses.
          </p>
          <div className="flex items-center gap-6 font-sans text-xs font-bold uppercase tracking-[0.14em]">
            <a
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="features-tiktok-link"
              className="text-stone-600 underline decoration-2 underline-offset-4 transition-colors hover:text-ink"
            >
              TikTok — @nailtapeapp
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="features-instagram-link"
              className="text-stone-600 underline decoration-2 underline-offset-4 transition-colors hover:text-ink"
            >
              Instagram — @nailtape_us
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
